import { render, staticRenderFns } from "./IndicatorIcon.vue?vue&type=template&id=22339ee8&scoped=true&"
import script from "./IndicatorIcon.vue?vue&type=script&lang=js&"
export * from "./IndicatorIcon.vue?vue&type=script&lang=js&"
import style0 from "./IndicatorIcon.vue?vue&type=style&index=0&id=22339ee8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22339ee8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
